import * as Types from "../../../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type GetCollectionTokensV2QueryVariables = Types.Exact<{
  chainId: Types.Scalars["Float"];
  tokenAddress: Types.Scalars["String"];
  tokenNameOrId: Types.Maybe<Types.Scalars["String"]>;
}>;

export type GetCollectionTokensV2Query = {
  getCollectionTokensV2: {
    __typename: "MarketplaceTokensPaginatedV2";
    edges: Array<{
      __typename: "MarketplaceToken";
      minted: boolean;
      imageUrl: string;
      chainId: number;
      animationUrl: string | null;
      tokenId: string;
      onChainId: string;
    }>;
  };
};

export const GetCollectionTokensV2Document = gql`
  query GetCollectionTokensV2(
    $chainId: Float!
    $tokenAddress: String!
    $tokenNameOrId: String
  ) {
    getCollectionTokensV2(
      chainId: $chainId
      tokenAddress: $tokenAddress
      tokenNameOrId: $tokenNameOrId
    ) {
      edges {
        minted
        imageUrl
        chainId
        animationUrl
        tokenId
        onChainId
      }
    }
  }
`;

/**
 * __useGetCollectionTokensV2Query__
 *
 * To run a query within a React component, call `useGetCollectionTokensV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionTokensV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionTokensV2Query({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      tokenAddress: // value for 'tokenAddress'
 *      tokenNameOrId: // value for 'tokenNameOrId'
 *   },
 * });
 */
export function useGetCollectionTokensV2Query(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionTokensV2Query,
    GetCollectionTokensV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionTokensV2Query,
    GetCollectionTokensV2QueryVariables
  >(GetCollectionTokensV2Document, options);
}
export function useGetCollectionTokensV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionTokensV2Query,
    GetCollectionTokensV2QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionTokensV2Query,
    GetCollectionTokensV2QueryVariables
  >(GetCollectionTokensV2Document, options);
}
export type GetCollectionTokensV2QueryHookResult = ReturnType<
  typeof useGetCollectionTokensV2Query
>;
export type GetCollectionTokensV2LazyQueryHookResult = ReturnType<
  typeof useGetCollectionTokensV2LazyQuery
>;
export type GetCollectionTokensV2QueryResult = Apollo.QueryResult<
  GetCollectionTokensV2Query,
  GetCollectionTokensV2QueryVariables
>;
